import { render, staticRenderFns } from "./HotspotEditDialog.vue?vue&type=template&id=0afa0556&scoped=true&"
import script from "./HotspotEditDialog.vue?vue&type=script&lang=js&"
export * from "./HotspotEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./HotspotEditDialog.vue?vue&type=style&index=0&id=0afa0556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa0556",
  null
  
)

export default component.exports